import React from 'react';
import FeaturedDashboard from './FeaturedDashboard';
import UserLayout from '../../components/Layout/UserLayout';

const title = 'Mis Botes Destacados';

export default async function action({ store }) {
  // Check if user is authenticated
  const isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login?redirect=/user/featured' };
  }

  return {
    title,
    component: <UserLayout showSideMenu={'listContainer'}><FeaturedDashboard title={title} /></UserLayout>,
  };
}
